<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="74" height="105" fill="none">
    <path
      fill="#462170"
      d="m49.87 22.47 1.16.95 1.21 1c.54.45 1.34.4 1.82-.12l.05-.05c.51-.55.46-1.43-.12-1.92L29.65 1.96a1.34 1.34 0 0 0-1.7-.01L2.37 22.85a1.33 1.33 0 1 0 1.68 2.06L27.89 5.64c.49-.4 1.2-.39 1.68.01l15.36 12.73"
    />
    <path
      stroke="#462170"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="m49.87 22.47 1.16.95 1.21 1c.54.45 1.34.4 1.82-.12l.05-.05c.51-.55.46-1.43-.12-1.92L29.65 1.96a1.34 1.34 0 0 0-1.7-.01L2.37 22.85a1.33 1.33 0 1 0 1.68 2.06L27.89 5.64c.49-.4 1.2-.39 1.68.01l15.36 12.73"
    />
    <path
      stroke="#462170"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2.5"
      d="M4.13 25.23v70.56h50V30.08M3.67 25.16h40.61"
    />
    <path
      stroke="#462170"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2.5"
      d="M17.36 32.7a3.1 3.1 0 0 1 3.09 3.09v5.86h-6.18v-5.86a3.1 3.1 0 0 1 3.09-3.09ZM29.41 46.99a3.1 3.1 0 0 1 3.09 3.08v5.86h-6.18v-5.86a3.1 3.1 0 0 1 3.1-3.08ZM41.23 61.09a3.1 3.1 0 0 1 3.08 3.08v5.86h-6.17v-5.86a3.1 3.1 0 0 1 3.09-3.08ZM38.23 37.14v-1.35a3.09 3.09 0 0 1 6.17 0v5.86h-6.17v-1.33M26.2 65.1v-1.35a3.09 3.09 0 0 1 6.17 0v5.86H26.2v-1.33M14.5 51.57v-1.35a3.09 3.09 0 0 1 6.17 0v5.86H14.5v-1.33M26.3 41.65v-5.86a3.09 3.09 0 0 1 6.17 0v5.86h-3M14.43 70v-5.87a3.09 3.09 0 0 1 6.17 0V70h-3M38.16 55.91v-5.86a3.09 3.09 0 0 1 6.17 0v5.86h-2.99M29.58 76.82c3.86 0 7 3.13 7 7V95.8H22.57V83.83c0-3.87 3.13-7.01 7-7.01Z"
    />
    <path
      stroke="#462170"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3.5"
      d="M29.59 95.51v-8.7"
    />
    <path
      stroke="#B1A8D3"
      stroke-miterlimit="10"
      stroke-width="6"
      d="m21.42 8.95 6.03-4.83a2.48 2.48 0 0 1 3.18.07l19.6 17c2.4 2.02 3.8 5 3.81 8.14l.31 53.43c.02 2.03.5 4.04 1.5 5.8 1.4 2.43 4.03 4.99 8.95 4.99 7.92 0 7.04-10.75-.2-10.75-7.22 0-13.38 12.31-8.7 20.72"
    />
  </svg>
</template>
